<div class="input-group" [class.focus]="inputgroupfocus">
    <span class="input-group-text pe-0 bg-white"><i class="pi pi-calendar"></i></span>
    <input type="datetime" class="form-control m-input" [(ngModel)]="datepart"
        bsDatepicker datePickerLuxonModifier [bsConfig]="{ adaptivePosition: true, showWeekNumbers: false }" 
        (focus)="dateFocus()" (blur)="dateBlur()" [disabled]="disabled" [readonly]="readonly" />
    <input type="time" class="form-control m-input" [(ngModel)]="timepart"
        (focus)="timeFocus()" (blur)="timeBlur()" onclick="this.showPicker()" [disabled]="disabled" [readonly]="readonly" />
</div>